import { Card, Section, TaskTitle, TopBar } from '../components/ui';

export function Privacy() {
  return (
    <main className="main task privacy">
      <TopBar to="/welcome" label="Back" />
      <TaskTitle
        title="Privacy Policy"
        sub="How Tiffinify collects, uses, and safeguards kitchen and customer information."
      />

      <Card pad>
        <div className="privacy-body">
          <p>
            <strong>Last updated:</strong> October 2026
          </p>

          <Section title="1. Information We Collect">
            <p>
              Tiffinify is an operating system for independent kitchens, home chefs, and meal subscription providers.
              To deliver our service, we collect:
            </p>
            <ul className="privacy-list">
              <li><strong>Kitchen Account Details:</strong> Name, phone number, email address, and kitchen configuration rules (delivery schedules, meal plans, UPI IDs).</li>
              <li><strong>Subscriber Information:</strong> Customer name, delivery address, phone number, dietary preference (Veg / Non-Veg / Egg), and delivery notes entered by you or submitted via customer registration.</li>
              <li><strong>Operations Data:</strong> Meal delivery marks, pause schedules, and recorded payment entries.</li>
            </ul>
          </Section>

          <Section title="2. How We Use Information">
            <p>We use the collected information exclusively to:</p>
            <ul className="privacy-list">
              <li>Generate accurate kitchen cooking sheets, portion tallies, and delivery schedules.</li>
              <li>Facilitate customer communications via WhatsApp links initiated directly by the kitchen.</li>
              <li>Calculate prorated subscription timelines, renewals, and balances.</li>
            </ul>
            <p>
              <strong>We do not sell, rent, or trade personal data</strong> to third-party advertisers or data brokers.
            </p>
          </Section>

          <Section title="3. Data Storage & Security">
            <p>
              All customer and kitchen data is stored securely using encrypted cloud databases and transmitted over HTTPS/TLS.
              Access to kitchen records is restricted to authenticated kitchen staff and authorized owners.
            </p>
          </Section>

          <Section title="4. Payments & UPI">
            <p>
              Tiffinify does not hold or escrow customer funds. Payment links use direct Unified Payments Interface (UPI) deep-links
              to the kitchen's own designated VPA. Payment transactions settle directly between the subscriber and the kitchen's bank account.
            </p>
          </Section>

          <Section title="5. Data Retention & Deletion">
            <p>
              Kitchen owners may modify, close, or request deletion of subscriber and kitchen records at any time directly through the
              application or by contacting support at support@tiffinify.com.
            </p>
          </Section>

          <Section title="6. Contact Us">
            <p>
              If you have any questions about this Privacy Policy or your data, please contact us at:
              <br />
              <a href="mailto:support@tiffinify.com" className="privacy-link">
                support@tiffinify.com
              </a>
            </p>
          </Section>
        </div>
      </Card>
    </main>
  );
}
